import { useMemo, useState } from 'react';
import { ConfirmationModal, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLegalTerms } from "../../../hooks/reactQuery/queries/useLegalTerms";
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_NAME_LENGTH = 80;
export let NameThisDocumentModalError = /*#__PURE__*/function (NameThisDocumentModalError) {
  NameThisDocumentModalError["LEGAL_TERMS_NAME_ALREADY_EXISTS"] = "LEGAL_TERMS_NAME_ALREADY_EXISTS";
  return NameThisDocumentModalError;
}({});
export const {
  NameThisDocumentModalTID
} = getTestIds();
export const NameThisDocumentModal = props => {
  const {
    currentFileName,
    onConfirm,
    dismissModal,
    currentLegalTermsId
  } = props;
  const {
    legalTerms
  } = useLegalTerms();
  const [name, setName] = useState(() => currentFileName);
  const [error, setError] = useState(undefined);
  const [isSaving, setIsSaving] = useState(false);
  const existingNames = useMemo(() => new Set(legalTerms.filter(term => term.id !== currentLegalTermsId).map(term => term.name.toLowerCase())), [legalTerms, currentLegalTermsId]);
  const isDuplicateName = existingNames.has(name.trim().toLowerCase());
  const isNameTooLong = name.length > MAX_NAME_LENGTH;
  const hasError = !!error || isDuplicateName || isNameTooLong;
  const helperText = useMemo(() => {
    if (isDuplicateName || error === NameThisDocumentModalError.LEGAL_TERMS_NAME_ALREADY_EXISTS) {
      return 'Document name already exists. Please use a different one.';
    } else if (isNameTooLong) {
      return 'Document name can be up to 80 characters';
    }
    return 'The document name is visible to your clients';
  }, [error, isDuplicateName, isNameTooLong]);
  const handleSave = async () => {
    if (!hasError && name.trim()) {
      setIsSaving(true);
      const result = await onConfirm(name.trim());
      if (result.success === true) {
        dismissModal(result.data);
      } else if (NameThisDocumentModalError[result.error]) {
        setError(result.error);
      }
      setIsSaving(false);
    }
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: currentLegalTermsId ? 'Rename document' : 'Name this document',
    testId: NameThisDocumentModalTID.NameThisDocumentModal(),
    textAlignCenter: false,
    content: /*#__PURE__*/_jsx(TextField, {
      collapseHelperText: true,
      testId: NameThisDocumentModalTID.NameThisDocumentModalInput(),
      label: "Document name",
      value: name,
      onChange: e => {
        setName(e.target.value);
        setError(undefined);
      },
      inputProps: {
        onKeyDown: e => {
          if (e.key === 'Enter' && !isSaving) {
            handleSave();
          }
        }
      },
      error: hasError,
      helperText: helperText,
      helperTextReserveSpace: true,
      width: "100%",
      autoFocus: true
    }),
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    primaryButtonDisabled: hasError || !name.trim(),
    primaryButtonLoading: isSaving,
    onPrimaryButtonClick: handleSave,
    onSecondaryButtonClick: () => dismissModal()
  });
};